import React, { type ReactElement } from 'react';
import styles from './AvailableProducts.css';

interface EnterpriseAdminListProps {
  message: string;
  enterpriseAdmins: string[];
}

const EnterpriseAdminList = ({
  message,
  enterpriseAdmins
}: EnterpriseAdminListProps): ReactElement => (
  <>
    <p className={styles.admins}>{message}</p>
    <ul>
      {enterpriseAdmins.map(admin => (
        <li key={admin}>{admin}</li>
      ))}
    </ul>
  </>
);

export default EnterpriseAdminList;
